import {
  ExtractFnReturnType,
  QueryConfigType,
  useQuery,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersEmployeeConditionSurveysShowResponseType } from "~/domains";

type RequestDataType = {
  id: string;
};

const request = async ({
  id,
}: RequestDataType): Promise<ApiManagersEmployeeConditionSurveysShowResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersEmployeeConditionSurveysShowResponseType>(
      `/api/managers/employee_condition_surveys/${id}`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersEmployeeConditionSurveysShow = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiManagersEmployeeConditionSurveysShowResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagerEmployeeConditionSurveysShow", id],
    () => request({ id }),
    {
      ...config,
    },
  );
};
